import type { TourStep } from '../types';

/** Последний шаг каждого тура генератора: где искать ответы после тура. */
export const finishStep: TourStep = {
  target: '[data-tour="lg-help-menu"]',
  title: 'Помощь всегда рядом',
  content: '«Помощь» на каждом экране генератора: тур по экрану, справка сбоку без ухода со страницы, вся справка с поиском и курс оператора.',
};
